import { useTranslation } from 'react-i18next';
import { useHoliday } from '../../theme/holiday';

/**
 * The Kyronyx mark with the active holiday theme's accessory laid over it. `logoSrc` is a public URL
 * used as `img src`, never CSS `content:url(data:...)`, whose base64 is truncated there. The accessory
 * span is positioned inside the logo box and styled entirely by the engine's `accStyle`.
 */
export function Logo(props: { size: number }) {
  const { t } = useTranslation('nav');
  const { hol } = useHoliday();
  return (
    <span style={{ position: 'relative', display: 'inline-flex', flex: 'none', width: props.size, height: props.size }}>
      <img src={hol.logoSrc} alt={t('header.ariaLogo')} style={{ width: props.size, height: props.size, display: 'block', flex: 'none' }} />
      {hol.show ? <span data-testid="logo-accessory" aria-hidden="true" style={hol.accStyle} /> : null}
    </span>
  );
}
